var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alertBox"},[_c('div',{staticClass:"alertBox_oldson"},[_c('div',{staticClass:"AO_oldson"},[_c('div',{on:{"click":_vm.nice}},[_vm._v("\n        "+_vm._s(_vm.vipji < 4
            ? "海星点转赠点数将转到对方赠点账户，请确认。"
            : "海星点转赠点数将转到对方赠点账户，使用赠点转赠将扣除本次转赠赠点数额的10%，请确认。")+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"AO_twoson",on:{"click":_vm.Takeme}},[_vm._v("我知道了")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24902a3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aletBox.vue
// module id = null
// module chunks = 